import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DsButtonVariants, DsModule } from '@levelaccess/design-system';
import { Observable, Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonPipesModule } from '../../../../shared/common-pipes.module';
import { DigitalPropertyService } from '../../../../services/digital-property.service';
import { BusMessageService } from '../../../../services/bus-message.service';
import { LoadErrorHandler } from '../../../../services/load-error-handler';

export enum DigitalPropertyStateAction {
  archive = 'archive',
  restore = 'restore',
}

@Component({
  selector: 'app-selfmanage-change-digital-property-state-modal.component.html',
  templateUrl: './selfmanage-change-digital-property-state-modal.component.html',
  imports: [DsModule, CommonPipesModule],
  providers: [BusMessageService],
  standalone: true,
})
export class SelfmanageChangeDigitalPropertyStateModalComponent implements OnInit {
  @Input() workspaceId: string;
  @Input() digitalPropertyId: string;
  @Input() changeTo: DigitalPropertyStateAction;

  public modalTitleAndActionName: string;

  private subscriptions: Subscription;

  constructor(
    public modal: NgbActiveModal,
    private digitalPropertyService: DigitalPropertyService,
    private loadErrorHandler: LoadErrorHandler,
  ) {
    this.subscriptions = new Subscription();
  }

  private onUpdateError(error: HttpErrorResponse): void {
    this.loadErrorHandler.handleError(
      'error_updating_digital_asset_state',
      error,
      SelfmanageChangeDigitalPropertyStateModalComponent.name,
      true,
    );
  }

  onChangeConfirmed(): void {
    const result$: Observable<void> =
      this.changeTo === DigitalPropertyStateAction.archive
        ? this.digitalPropertyService.archive(this.workspaceId, this.digitalPropertyId)
        : this.digitalPropertyService.restore(this.workspaceId, this.digitalPropertyId);
    this.subscriptions.add(
      result$.subscribe({
        next: () => this.modal.close(this.changeTo),
        error: this.onUpdateError.bind(this),
      }),
    );
  }

  onCancel(): void {
    this.modal.dismiss();
  }

  ngOnInit(): void {
    this.modalTitleAndActionName =
      this.changeTo === DigitalPropertyStateAction.archive ? 'archive_property_modal_title' : 'restore_property_modal_title';
  }

  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  protected readonly DigitalPropertyStateAction: typeof DigitalPropertyStateAction = DigitalPropertyStateAction;
}
